const LINKS = [
	{
		label: 'О себе',
		link: '#about',
	},
	{
		label: 'Карьера',
		link: '#career',
	},
	{
		label: 'Выступления',
		link: '#performances',
	},
]

export { LINKS }
